<template>
  <div ref="swiperEl" class="swiper">
    <slot name="container-start"></slot>
    <div class="swiper-wrapper" :class="wrapperClass">
      <slot name="wrapper-start"></slot>
      <slot />
      <slot name="wrapper-end"></slot>
    </div>
    <slot name="container-end"></slot>
  </div>
</template>
<script>
import { defineComponent, nextTick, onBeforeUnmount, onMounted, onUpdated, provide, ref } from '@nuxtjs/composition-api';
import Swiper from 'swiper/swiper.esm.js';

export default defineComponent({
  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },
    modules: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => {},
    },
    wrapperClass: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const swiperEl = ref(null);
    const swiperRef = ref(null);
    provide('swiperSettings', props.settings);
    onUpdated(() => {
      swiperRef.value?.update();
    });
    onBeforeUnmount(() => {
      if (swiperRef.value && !swiperRef.value?.destroyed) {
        swiperRef.value?.destroy(true, true);
      }
    });
    onMounted(async () => {
      await nextTick();
      if (props.settings?.navigation?.nextEl && typeof props.settings?.navigation?.nextEl !== 'string') {
        props.settings.navigation.nextEl = props.settings?.navigation?.nextEl.value?.$el || props.settings?.navigation?.nextEl.value;
      }
      if (props.settings?.navigation?.nextEl && typeof props.settings?.navigation?.prevEl !== 'string') {
        props.settings.navigation.prevEl = props.settings?.navigation?.prevEl.value?.$el || props.settings?.navigation?.prevEl.value;
      }
      swiperRef.value = new Swiper(swiperEl.value, {
        ...props.settings,
        init: false,
        modules: props.modules,
        pagination: props.pagination,
      });
      swiperRef.value.init();
      emit('swiper', swiperRef.value);
    });
    provide('swiper', swiperRef);

    return {
      swiperEl,
    };
  },
});
</script>

<style lang="scss">
.swiper-pagination {
  display: flex;
  justify-content: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 0px;
  width: 100%;
  height: auto;
  z-index: 2;

  :not(:last-child) {
    margin-right: 8px;
  }

  &-bullet {
    cursor: pointer;
    height: 0.5rem;
    width: 0.5rem;
    border-radius: 100%;
    background-color: #8197af;
  }

  &-bullet-active {
    cursor: pointer;
    background-color: #d6d8e0;
    height: 0.5rem;
    width: 0.5rem;
    border-radius: 100%;
  }
}
</style>
